module.exports = __webpack_public_path__ + "static/media/star.550ec2c8.svg";